
import DOMPurify from 'dompurify';

// Lägger automatiskt till rel="noopener noreferrer" på target="_blank"-länkar
// för att förhindra reverse tabnabbing, oavsett vad admin skrivit in.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Sanerar HTML som admin skrivit fritt i CMS-textfält (t.ex. infosidornas
 * "Innehåll (HTML/Text)") innan det renderas med dangerouslySetInnerHTML.
 * Tillåter grundläggande formatering — inget som kan köra script eller
 * läsa/ändra sidan (event handlers, <script>, <iframe>, style-attribut osv
 * är alltid bortsanerat).
 */
export const sanitizeRichHtml = (html: string | null | undefined): string => {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'p', 'br', 'hr',
            'b', 'strong', 'i', 'em', 'u', 's',
            'a', 'ul', 'ol', 'li',
            'h2', 'h3', 'h4', 'blockquote',
            'img'
        ],
        ALLOWED_ATTR: ['href', 'target', 'src', 'alt'],
    });
};

/**
 * Sanerar korta enradsfält (t.ex. hero-rubriker) där enda avsedda HTML är
 * radbrytningar (\n -> <br/>). Allt annat markup stängs av — här finns
 * aldrig ett legitimt behov av länkar, listor eller bilder.
 */
export const sanitizeInlineHtml = (html: string | null | undefined): string => {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['br'],
        ALLOWED_ATTR: [],
    });
};
